import { render, staticRenderFns } from "./PrincipalDialog.vue?vue&type=template&id=947e8c6a"
import script from "./PrincipalDialog.vue?vue&type=script&lang=js"
export * from "./PrincipalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports